import React, { useState } from "react";
import "./ManualDepositPopup.css";
import { IoChevronBackSharp } from "react-icons/io5";
import axios from "axios";
import {
  __,
  addNewStyle,
  CRISTP_ID,
  decode,
  defaultAvatar,
  encode,
  getUID,
  sendNotfication,
  toUSD,
  wait,
} from "../../../Helper";

function UpiGetway({ isOpen, onClose }) {
  const [amount, setAmount] = useState("");
  const [utrNumber, setUtrNumber] = useState("");
  const [depositPaymentSetting, setDepositPaymentSetting] = useState({});
  const [step, setStep] = useState(1); // Step 1 for amount entry, Step 2 for QR/UTR entry
  const [depositType, setDepositType] = useState("manual"); // New state for deposit type selection
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // Error message state

  if (!isOpen) return null;

  const handleGatewayDeposit = async (event) => {
    event.preventDefault(); // Prevent form submission default behavior
    setLoading(true); // Set loading to true to indicate process start

    if (!amount || amount < 500) {
      setErrorMessage("Please enter minimum amount 500 INR"); // Show error message
      return;
    }
    setErrorMessage(""); // Clear error if valid

    try {
      // Sending POST request to the API
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/api/paynow/upi",
        {
          money: parseFloat(amount),
          uid: getUID,
        }
      );

      const data = response?.data;

      // Check if response data is valid
      if (!data) {
        alertMessage("Something went wrong! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Handle error status from the API
      if (data?.status === false) {
        alertMessage(data?.message || "Payment failed! Please try again.");
        setLoading(false); // Reset loading state
        return;
      }

      // Redirect to the provided web URL
      if (data?.urls?.web_url) {
        window.location.href = data.urls.web_url;
      } else {
        sendNotfication(
          "Payment URL is missing! Please contact support.",
          "danger",
          "bottom-left"
        );
      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false); // Reset loading state in all cases
    }
  };

  return (
    <div className="popup-overlay-inner-main-543">
      <div className="popup-container-inner-main-543">
        <div className="vip2-popup-page" style={{ background: "#323738" }}>
          <div className="vip2-popup-page-btn" onClick={onClose}>
            <IoChevronBackSharp />
          </div>
          UPI Method
        </div>
        <div
          className="main-int-overflow-sroll"
          style={{
            padding: "20px",
            background: "#232626",
            borderRadius: "0px 0px 10px 10px ",
          }}
        >
          <div
            style={{
              background: "#323738",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div style={{ marginBottom: "20px" }} className="main-int-uew-1235">
              <div className="main-int-uew-1236">Deposit Currency</div>
              <div className="main-int-uew-1237">
                <img
                  className="main-int-uew-1238"
                  src="assets/bcimages/INR.webp"
                  alt="INR"
                />
                <div>INR</div>
              </div>
            </div>
            <div className="main-int-uew-new-1">UPI Deposit</div>
            <div className="popup-body-inner-main-543">
              <div
                style={{ textAlign: "start" }}
                className="amount-input-inner-main-543"
              >
                <img style={{ width: "60px" }} src="assets/images/upipay.png" />
              </div>
            </div>

            {/* <div
              style={{
                margin: "20px 0px",
                background: "#514634",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "10px",
              }}
            >
              <img
                style={{ width: "50px" }}
                src="assets/images/bonus-gift.webp"
              />
              <div style={{ fontWeight: "bold", textAlign: "start" }}>
                Get extra <span style={{ color: "#FF9820" }}>180%</span> bonus
                on minimum of{" "}
                <span style={{ color: "#FF9820" }}>₹1,056.84</span> deposit
              </div>
            </div> */}

            <div className="main-int-uew-new-1">500 - 50,000 INR</div>

            <div className="popup-body-inner-main-543">
              <input
                className="amount-input-inner-main-543"
                type="number"
                placeholder="Enter Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
              {errorMessage && (
                <div className="error-message-main-error-inr">
                  {errorMessage}
                </div>
              )}
              <button
                onClick={handleGatewayDeposit}
                className="submit-button-inner-main-543"
              >
                Submit
              </button>
            </div>

            <div
              className="deposit-rules-text-12"
              style={{
                background: "#314940",
                color: "#B3BEC1",
              }}
            >
              <div>
                1. Your transfer amount has to MATCH the submission amount.
              </div>
              <div>
                2. Each Order ID can ONLY be used once to avoid duplicates.
              </div>{" "}
              <div>
                3. Please follow the deposit guideline to make deposit,
                otherwise your deposit will be missing.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpiGetway;
